import { render, staticRenderFns } from "./NameNumberStyling.vue?vue&type=template&id=05809d2c&scoped=true"
import script from "./NameNumberStyling.vue?vue&type=script&lang=js"
export * from "./NameNumberStyling.vue?vue&type=script&lang=js"
import style0 from "./NameNumberStyling.vue?vue&type=style&index=0&id=05809d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05809d2c",
  null
  
)

export default component.exports